export const STATUS_TEXT = "#27272a"

// Same soft palette as the Portfolio Status chart bars' badge counterparts.
export const STATUS_STYLE: { [key: string]: { label: string; bg: string; color: string } } = {
  ahead: { label: "Ahead", bg: "#C3D4F6", color: STATUS_TEXT },
  on_track: { label: "On Track", bg: "#B0DCC6", color: STATUS_TEXT },
  timing_review: { label: "Timing Review", bg: "#F0C6C6", color: STATUS_TEXT },
  // A deal inside its first months has not been given time to perform, so it is not graded.
  new: { label: "New", bg: "#ECF7EA", color: STATUS_TEXT }
}
